import classNames from "classnames";
import * as React from "react";
import { FC } from "react";
import { Box } from "~/sharedComponents/layout";
import { CssProps } from "~/sharedComponents/layout/cssProps";
import * as styles from "../Button.less";

type Props = CssProps & {
    className?: string;
    variant?: "segmented";
};

export const ButtonsGroup: FC<Props> = props => {
    const { className, variant, ...rest } = props;
    const classes = classNames(styles.btns_group, variant === "segmented" && styles.segmented, className);

    return <Box {...rest} className={classes} />;
};
